export default "/_next/static/images/Urban-39a582235404cf347ca8fcc38017a993.png";